import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import AUHeader from './AUHeader';

const INSIGHTS = [
  'Por qué tu físico no refleja lo que entrenas — y qué está fallando exactamente.',
  'Qué ajustes concretos cambiarían tu progreso en las próximas semanas.',
  'Cómo estructurar tu entrenamiento sin seguir adivinando qué hacer.',
  'Si AU Coaching es para ti o no — con honestidad, sin presión.',
];

const QualifiedPostFormSection = ({ agendaUrl, onAgendado }) => {
  return (
    <Box sx={{ bgcolor: '#fff', fontFamily: 'Kanit, sans-serif', minHeight: '100vh' }}>
      <AUHeader />

      <Container maxWidth="md" sx={{ px: { xs: 2, md: 3 } }}>

        {/* ── Hero ── */}
        <Box sx={{ pt: { xs: 3, md: 4 }, pb: { xs: 2.5, md: 3 } }}>
          <Typography sx={{
            fontSize: 12, fontWeight: 700, letterSpacing: 2.5,
            color: '#1A7FFF', textTransform: 'uppercase',
            mb: 1, fontFamily: 'Kanit, sans-serif',
          }}>
            Aplicación aprobada
          </Typography>
          <Typography component="h1" sx={{
            fontFamily: 'Kanit, sans-serif', fontWeight: 800,
            fontSize: { xs: '1.9rem', md: '2.8rem' },
            lineHeight: 1.1, color: '#0F1117', mb: 1,
          }}>
            Estás a una llamada de{' '}
            <Box component="span" sx={{ color: '#1A7FFF' }}>tu mejor físico</Box>.
          </Typography>
          <Typography sx={{
            fontFamily: 'Kanit, sans-serif',
            fontSize: { xs: '0.95rem', md: '1.05rem' },
            color: '#64748B', lineHeight: 1.6,
          }}>
            Entres a AU Coaching o no, sales con los pasos claros para dejar de estar estancado.
          </Typography>
        </Box>

        {/* ── Badge asesoría ── */}
        <Box sx={{ mb: 2.5 }}>
          <Box sx={{
            display: 'inline-flex', alignItems: 'stretch',
            borderRadius: '100px', overflow: 'hidden',
            border: '1.5px solid #1A7FFF',
            boxShadow: '0 2px 8px rgba(26,127,255,0.18)',
          }}>
            <Box sx={{
              bgcolor: '#1A7FFF', px: 2, py: 0.75,
              display: 'flex', alignItems: 'center',
            }}>
              <Typography sx={{
                fontFamily: 'Kanit, sans-serif', fontWeight: 800,
                fontSize: '0.82rem', color: '#fff',
                letterSpacing: 1, textTransform: 'uppercase',
              }}>
                Gratis
              </Typography>
            </Box>
            <Box sx={{
              bgcolor: '#F1F5F9', px: 2, py: 0.75,
              display: 'flex', alignItems: 'center', gap: 0.75,
            }}>
              <Typography sx={{
                fontFamily: 'Kanit, sans-serif', fontWeight: 600,
                fontSize: '0.82rem', color: '#0F1117',
                letterSpacing: 0.3,
              }}>
                Asesoría
              </Typography>
              <Box sx={{ width: 3, height: 3, borderRadius: '50%', bgcolor: '#94A3B8' }} />
              <Typography sx={{
                fontFamily: 'Kanit, sans-serif', fontWeight: 600,
                fontSize: '0.82rem', color: '#64748B',
              }}>
                30 min
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* ── Aviso: agendar antes de salir ── */}
        <Box sx={{
          bgcolor: '#FFF4E5', border: '1px solid rgba(251,140,0,0.35)',
          borderRadius: 2, p: 2, mb: 2.5,
          display: 'flex', gap: 1.25, alignItems: 'flex-start',
        }}>
          <Typography sx={{ fontSize: '1.1rem', lineHeight: 1.3 }}>⚠️</Typography>
          <Typography sx={{
            fontFamily: 'Kanit, sans-serif',
            fontSize: { xs: '0.9rem', md: '0.95rem' },
            color: '#7C2D12', lineHeight: 1.55,
          }}>
            <strong>No cierres esta página sin agendar tu llamada.</strong> Tu aplicación ya está aprobada: el cupo se asegura solo al elegir tu horario aquí abajo.
          </Typography>
        </Box>

        {/* En mobile el calendario va primero y la lista de beneficios después */}
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>

        {/* ── Lo que te llevas ── */}
        <Box sx={{ mb: { xs: 4, md: 5 }, order: { xs: 2, md: 1 } }}>
          <Typography component="h2" sx={{
            fontFamily: 'Kanit, sans-serif', fontWeight: 800,
            fontSize: { xs: '1.2rem', md: '1.5rem' },
            color: '#0F1117', mb: 2,
          }}>
            En 30 minutos vas a saber:
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            {INSIGHTS.map((text, i) => (
              <Box
                key={i}
                sx={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 2,
                  py: 1.75,
                  borderBottom: i < INSIGHTS.length - 1 ? '1px solid #F1F5F9' : 'none',
                }}
              >
                <Box sx={{
                  minWidth: 26, height: 26,
                  bgcolor: '#EBF3FF',
                  borderRadius: '50%',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  flexShrink: 0, mt: '2px',
                }}>
                  <Typography sx={{
                    fontFamily: 'Kanit, sans-serif', fontWeight: 800,
                    fontSize: '0.78rem', color: '#1A7FFF', lineHeight: 1,
                  }}>
                    {i + 1}
                  </Typography>
                </Box>
                <Typography sx={{
                  fontFamily: 'Kanit, sans-serif', fontWeight: 400,
                  fontSize: { xs: '0.93rem', md: '1rem' },
                  color: '#374151', lineHeight: 1.6,
                }}>
                  {text}
                </Typography>
              </Box>
            ))}
          </Box>

          <Typography sx={{
            fontFamily: 'Kanit, sans-serif',
            fontSize: '0.75rem', letterSpacing: 1.5,
            color: '#94A3B8', textTransform: 'uppercase',
            mt: 2.5,
          }}>
            Gratis. Sin compromiso. Con información que puedes aplicar altiro.
          </Typography>
        </Box>

        {/* ── Agenda (Google Calendar) ── */}
        <Box sx={{
          pb: { xs: 3, md: 6 },
          borderTop: { xs: 'none', md: '1px solid #E2E8F0' },
          pt: { xs: 0.5, md: 4 },
          order: { xs: 1, md: 2 },
        }}>
          <Typography component="h3" sx={{
            fontFamily: 'Kanit, sans-serif', fontWeight: 800,
            fontSize: { xs: '1.35rem', md: '1.7rem' },
            color: '#0F1117', mb: 1.5,
          }}>
            Elige tu horario:
          </Typography>

          <Box sx={{
            bgcolor: '#fff',
            border: '1px solid #E2E8F0',
            borderRadius: 2,
            overflow: 'hidden',
            boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
          }}>
            {/* En mobile el alto cubre el widget completo de Google (~1276px
                más la lista de horarios) para que no haya scroll interno */}
            <Box
              component="iframe"
              src={agendaUrl}
              title="Agenda tu llamada con AU Coaching"
              sx={{ border: 0, display: 'block', width: '100%', minWidth: '320px', height: { xs: 1450, md: 900 } }}
            />
          </Box>

          {/* Google Calendar no avisa cuando alguien reserva (a diferencia de
              Calendly), así que el paso siguiente lo gatilla el propio lead. */}
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2.5 }}>
            <Button
              variant="contained"
              onClick={onAgendado}
              sx={{
                px: 4, py: 1.25,
                fontFamily: 'Kanit, sans-serif', fontWeight: 700,
                textTransform: 'none', fontSize: '1rem',
                bgcolor: '#1A7FFF', '&:hover': { bgcolor: '#1568D9' },
              }}
            >
              Ya agendé mi llamada →
            </Button>
          </Box>
        </Box>

        </Box>

      </Container>
    </Box>
  );
};

export default QualifiedPostFormSection;
